import http from '../../../Services/api.laravel.http';

export const dailyMovementService = {
    dailyMovementChecker: (formdata) =>
        http.post('/admin/daily/daily-movement/movement-checker', formdata),
    getDailyMovement: (formdata) =>
        http.post('/admin/daily/daily-movement', formdata),
};
